import { render, staticRenderFns } from "./shfx2.vue?vue&type=template&id=c4320c8a&scoped=true"
import script from "./shfx2.vue?vue&type=script&lang=js"
export * from "./shfx2.vue?vue&type=script&lang=js"
import style0 from "./shfx2.vue?vue&type=style&index=0&id=c4320c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4320c8a",
  null
  
)

export default component.exports